import React from 'react';
import classnames from 'classnames';

export const heroDesktop = ({ className = 'd-none d-md-block' } = {}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{
      objectFit: 'cover',
    }}
    viewBox="0 0 1200 345"
    width={1200}
    className={classnames('pos-a top-0 left-0 w-100 h-100', className)}
    preserveAspectRatio="none"
  >
    <linearGradient
      id="home-hero-wavy-desktop-lg1"
      x1={600}
      x2={600}
      y1={0}
      y2={526.995}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} style={{ stopColor: '#007ee5' }} />
      <stop offset={1} style={{ stopColor: '#63d9ea' }} />
    </linearGradient>
    <path
      d="M577 343.6c218.5-4.9 428.8-27.7 623-68V0H0v297.9c181.7 30.4 376 45.6 577 45.7z"
      style={{ fill: 'url(#home-hero-wavy-desktop-lg1)' }}
    />
    <defs>
      <filter
        id="home-hero-wavy-desktop-filter"
        width={1200}
        height={283.5}
        x={0}
        y={61.5}
        filterUnits="userSpaceOnUse"
      >
        <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
      </filter>
    </defs>
    <mask id="home-hero-wavy-desktop-mask" width={1200} height={283.5} x={0} y={61.5} maskUnits="userSpaceOnUse">
      <g style={{ filter: 'url(#home-hero-wavy-desktop-filter)' }}>
        <defs>
          <path id="home-hero-wavy-desktop-def" d="M0 0h1200v345H0z" />
        </defs>
        <clipPath id="home-hero-wavy-desktop-clip-path">
          <use xlinkHref="#home-hero-wavy-desktop-def" style={{ overflow: 'visible' }} />
        </clipPath>
        <linearGradient
          id="home-hero-wavy-desktop-lg2"
          x1={606}
          x2={606}
          y1={463}
          y2={975.532}
          gradientTransform="translate(0 -446)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} style={{ stopColor: '#154a99' }} />
          <stop offset={1} style={{ stopColor: '#63d9ea' }} />
        </linearGradient>
        <path
          d="M-112.5 288.5-98 17h1395l27.5 245c-226.8 22.6-487.7 80.4-725.6 83-237.5-2.7-485-33.9-711.4-56.5z"
          style={{
            clipPath: 'url(#home-hero-wavy-desktop-clip-path)',
            fill: 'url(#home-hero-wavy-desktop-lg2)',
          }}
        />
      </g>
    </mask>
    <g
      style={{
        mask: 'url(#home-hero-wavy-desktop-mask)',
      }}
    >
      <path
        d="M1200 137.9c-137.5 21.2-282.8 32.7-432.5 34.3C489.2 169 225.9 132 0 61.5V345h1200V137.9z"
        style={{ fill: '#fef3c7', fillOpacity: '.17' }}
      />
      <path
        d="M1200 345V102.3c-61.7-7.5-123.2-12.3-184.5-14.3-104.1 3.8-208.9 15-314.1 34.2C475.2 164.1 264.1 240.5 72.5 345H1200z"
        style={{ fill: '#fef3c7', fillOpacity: '.15' }}
      />
      <path
        d="M414.2 301.4c-115.5-20.8-233.6-33.6-354-37.8-20.1-.6-40.2-1-60.2-1.1V345h565.3c-50.1-16.3-100.5-30.8-151.1-43.6z"
        style={{ fill: '#154a99', fillOpacity: '.29' }}
      />
      <path
        d="M1200 345V180.5c-39.2-.8-78.7-.6-118.4.7-264.5 9.4-515.8 66.9-746.1 163.8H1200z"
        style={{ fill: '#2070e8', fillOpacity: '.15' }}
      />
    </g>
  </svg>
);

export const heroMobile = ({ className = 'd-md-none' } = {}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 375 291"
    width={375}
    className={classnames('pos-a top-0 left-0 w-100 mh-100', className)}
    preserveAspectRatio="none"
  >
    <path d="M0 0h375v291H0z" style={{ fill: '#fff' }} />
    <linearGradient
      id="home-hero-wavy-mobile-lg"
      x1={187.5}
      x2={187.5}
      y1={292}
      y2={-148.354}
      gradientTransform="matrix(1 0 0 -1 0 292)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} style={{ stopColor: '#007ee5' }} />
      <stop offset={1} style={{ stopColor: '#63d9ea' }} />
    </linearGradient>
    <path d="M375 254.7C256 278.3 129.4 285.8 0 290V0h375" style={{ fill: 'url(#home-hero-wavy-mobile-lg)' }} />
    <defs>
      <filter id="home-hero-wavy-mobile-filter" width={375} height={253.7} x={0} y={37.3} filterUnits="userSpaceOnUse">
        <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
      </filter>
    </defs>
    <mask id="home-hero-wavy-mobile-mask" width={375} height={253.7} x={0} y={37.3} maskUnits="userSpaceOnUse">
      <linearGradient
        id="home-hero-wavy-mobile-lg2"
        x1={-49.5}
        x2={-49.5}
        y1={275}
        y2={-156.277}
        gradientTransform="matrix(1 0 0 -1 0 292)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#154a99' }} />
        <stop offset={1} style={{ stopColor: '#63d9ea' }} />
      </linearGradient>
      <path
        d="M-655 245.5-642.8 17H532.8L556 223.2c-191.1 19-411 67.6-611.5 69.8-200.1-2.3-408.7-28.5-599.5-47.5z"
        style={{
          fill: 'url(#home-hero-wavy-mobile-lg2)',
          filter: 'url(#home-hero-wavy-mobile-filter)',
        }}
      />
    </mask>
    <g
      style={{
        mask: 'url(#home-hero-wavy-mobile-mask)',
      }}
    >
      <path
        d="M375 100c-4.2.1-8.3.1-12.5.2C238 98.8 116.5 90.6 0 75.6V291h375V100z"
        style={{ fill: '#fef3c7', fillOpacity: '7.000000e-02' }}
      />
      <path
        d="M296.4 50.2C194.4 69.1 95.4 95 0 127.3V291h375V37.3c-26.2 3.8-52.4 8.1-78.6 12.9z"
        style={{ fill: '#fef3c7', fillOpacity: '5.000000e-02' }}
      />
      <path
        d="M9.2 229.4c-3-.6-6.1-1.1-9.2-1.6V291h213.4c-67.6-23.8-135.7-44.3-204.2-61.6z"
        style={{ fill: '#154a99', fillOpacity: '.19' }}
      />
      <path
        d="M375 141.4C245.4 164.7 120.1 199.7 0 245.2V291h375V141.4z"
        style={{ fill: '#6e28c3', fillOpacity: '8.000000e-02' }}
      />
    </g>
  </svg>
);

export const transparentLayer = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 580 216"
    width="100%"
    height="100%"
    className="pos-a d-none d-lg-block w-100 transparent-layer"
    preserveAspectRatio="none"
  >
    <path
      d="M0 12C0 5.4 5.4 0 12 0h562.9c2.4 0 4.3 2.1 4 4.5l-21.8 159.6c-4.1 29.7-29.4 51.9-59.4 51.9H12c-6.6 0-12-5.4-12-12V12z"
      style={{ fill: '#fff', fillOpacity: '.24' }}
    />
    <linearGradient
      id="transparent-layer-lg"
      x1={130.109}
      x2={270.651}
      y1={367.411}
      y2={97.94}
      gradientTransform="matrix(1 0 0 -1 0 218)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} style={{ stopColor: '#fcde67', stopOpacity: '0' }} />
      <stop offset=".143" style={{ stopColor: '#fcde67' }} />
      <stop offset=".304" style={{ stopColor: '#63d9ea' }} />
      <stop offset={1} style={{ stopColor: '#63d9ea', stopOpacity: '0' }} />
    </linearGradient>
    <path
      d="M12 .5h511.5V144c0 39.5-32 71.5-71.5 71.5H12C5.6 215.5.5 210.4.5 204V12C.5 5.6 5.6.5 12 .5z"
      style={{ fill: 'none', stroke: 'url(#transparent-layer-lg)' }}
    />
  </svg>
);
